<template>
    <el-button type="primary" :disabled="modelValue.length == 0" @click="fetchData = true" size="large">
        <i class="ti ti-upload pr-2"></i>
        <download-excel :fields="fields" worksheet="Worksheet" name="export.xls" :data="modelValue">
            Export
        </download-excel>
    </el-button>
</template>
<script>
    export default {
        props: {
            modelValue: {
                type: Array,
                default: [],
            },
            headers: null,
        },
        data() {
            return {
                data: [],
                fields: {},
            }
        },
        mounted() {
            this.getJsonField()
        },
        methods: {
            getJsonField() {
                if (this.headers) {
                    this.headers.forEach(header => {
                        this.fields[header.text] = header.value
                    })
                }
            },
        },
    }
</script>
